<app-pg-change-password></app-pg-change-password>
<app-pg-edit-profile></app-pg-edit-profile> <!-- TODO: ma questa roba serve? -->

<ng-template #loginTemplate>
    @if (isLoading || isResetting) {
        <app-pg-loading [isOverlay]="true"></app-pg-loading>
    }
    <div class="modal-body">
        <div class="PGLoginHandler">
            <div class="PGLoginHandler-Title mb-3">
                @if (userRequest == null) {
                    <h3 id="pg-login-handler-title" class="mb-0">{{ 'pg-login-handler.title-login' | locTranslate }}</h3>
                }
                @else {
                    <h3 id="pg-login-handler-title" class="mb-0">{{ 'pg-login-handler.title-' + userRequest | locTranslate }}</h3>
                }
                <div>
                    <app-pg-help></app-pg-help>
                </div>
                <div class="ms-1">
                    <app-pg-language-selector></app-pg-language-selector>
                </div>
                @if (canDismiss) {
                    <div class="ms-1">
                        <button type="button" class="modal-close btn btn-link" (click)="dismissLogin()" [attr.aria-label]="'pg-login-handler.close' | locTranslate">
                            <i class="fa-regular fa-times fa-lg" aria-hidden="true"></i>
                        </button>
                    </div>
                }
            </div>
            @if (customMessage != null) {
                <p class="text-muted mb-3">
                    {{customMessage}}
                </p>
            }
            @if (availableModes.length > 1) {
                <div class="mb-3 d-flex justify-content-around">
                    @for (mode of availableModes; track mode) {
                        <button class="btn btn-sm btn-white py-0 {{mode == currentMode ? 'btn-white-selected' : ''}}" (click)="setCurrentMode(mode)">{{ 'pg-login-handler.link-' + mode | locTranslate }}</button>
                    }
                </div>
            }
            <hr/>
            @if (currentMode == 'default') {
                <app-pg-login-handler-default (setUserRequest)="onSetUserRequest($event)"></app-pg-login-handler-default>
            }
            @if (currentMode == 'otp') {
                <app-pg-login-handler-otp></app-pg-login-handler-otp>
            }
            @if (currentMode == 'code') {
                <app-pg-login-handler-code></app-pg-login-handler-code>
            }
        </div>
    </div>
</ng-template>